import * as Yup from 'yup';
import { t } from '@transifex/native';

export const nameValidation = Yup.string()
  .strict(false)
  .trim()
  .max(150)
  .required(t('Required'));
